<script>
  import { onMount } from "svelte";
  import ServiceApi from "./service.api.js";
  import WidgetService from "./widget-service.js";
  import url from "./url";

  const placement = "product_page_button";
  const serviceApi = new ServiceApi();
  const widgetService = new WidgetService();

  export let shopId = "";
  export let variantId = "";

  // component variables
  let show = false;
  let widgetEnabled = false;

  let data = undefined;
  let placements = undefined;

  let buttonText = "ADD FROM RE:TURN";

  let currentPriceRef;
  let originalPriceRef;

  $: $url, getData();

  onMount(async () => {
    if (!shopId || !variantId) {
      console.warn("uturn-product-page-button : shopId / variantId missing");
      return;
    }
    const placementsData = await serviceApi.GetPlacementsData(shopId);
    placements = placementsData?.placements;
    widgetEnabled = widgetService.checkPlacement(placements, placement);
    await getData();
    setOriginalPriceFontSize();
  });

  function setOriginalPriceFontSize() {
    if (currentPriceRef && originalPriceRef) {
      const currentPriceFontSize = window
        .getComputedStyle(currentPriceRef)
        .getPropertyValue("font-size");
      const currentPriceLineHeight = window
        .getComputedStyle(currentPriceRef)
        .getPropertyValue("line-height");
      const originalPriceFontSize = `calc(${currentPriceFontSize} - 2px)`;
      const originalPriceLineHeight = `calc(${currentPriceLineHeight} - 1px)`;
      originalPriceRef.style.fontSize = originalPriceFontSize;
      originalPriceRef.style.lineHeight = originalPriceLineHeight;
    }
  }

  async function getData() {
    if (!widgetEnabled) {
      return;
    }

    var urlVariantId = widgetService.getVariantIdFromUrl();
    if (urlVariantId) {
      variantId = urlVariantId;
    }

    data = await serviceApi.GetAlternativeProduct(shopId, variantId);

    if (!data.alternative || data.alternative.length < 1) {
      show = false;
    } else {
      show = true;
    }
  }

  function visitProduct() {
    if (data && data.alternative.length > 0 && data.alternative[0].variant_url)
      window.open(
        `${data.alternative[0].variant_url}?widget=uturn-product-page-button`,
        "_self"
      );
  }
</script>

{#if widgetEnabled && show}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <section
    class="uturn-product-page-button-container"
    on:click={visitProduct}
  >
    <div class="uturn-product-page-button-container-text">
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.9739 1.23095C15.9102 1.03736 15.7408 0.899609 15.5383 0.876766C15.5243 0.875266 14.3606 0.744203 12.6757 0.744141C11.5751 0.744172 10.2521 0.799984 8.87894 0.986484C7.84903 1.12652 6.79075 1.33989 5.77544 1.6617C5.01403 1.90317 4.27653 2.2057 3.59419 2.58677C3.08256 2.87261 2.60191 3.20283 2.16769 3.58523C1.5165 4.1583 0.969969 4.85111 0.590407 5.67505C0.210282 6.49864 -0.00043682 7.44967 6.79897e-07 8.52583C6.79897e-07 9.25577 0.0960007 10.0437 0.298188 10.8943C0.485094 11.6806 0.762844 12.5208 1.14041 13.4204C0.748469 14.2316 0.406688 15.0871 0.128032 15.9882C0.0431882 16.2624 0.196751 16.5536 0.471063 16.6384C0.745313 16.7232 1.03647 16.5696 1.12131 16.2953C1.35309 15.546 1.63138 14.8298 1.94794 14.1451C2.73516 14.5378 3.53403 14.8479 4.32866 15.0697C5.28691 15.3371 6.23913 15.4768 7.15712 15.4769C8.02556 15.4769 8.86388 15.3516 9.64347 15.0886C10.228 14.8914 10.7793 14.6165 11.2819 14.2606C12.0362 13.7273 12.6787 13.0111 13.1627 12.1192C13.6473 11.2272 13.9745 10.1619 14.1166 8.9242C14.4813 5.7457 14.9464 3.91277 15.3062 2.89848C15.4859 2.3913 15.6389 2.08908 15.7367 1.92489C15.7855 1.84277 15.8205 1.79511 15.8378 1.77308C15.8422 1.76758 15.8454 1.76364 15.8475 1.76123L15.8502 1.75811L15.8501 1.75802C15.9867 1.61952 16.0351 1.41708 15.9739 1.23095ZM1.78097 12.2079C1.58153 11.66 1.42572 11.1424 1.30963 10.654C1.12372 9.87164 1.03966 9.16442 1.03966 8.52583C1.03978 7.78142 1.15328 7.13042 1.35506 6.55427C1.53188 6.05011 1.77656 5.60233 2.07919 5.19911C2.34403 4.84645 2.65359 4.52811 3.00159 4.2402C3.61022 3.73645 4.3375 3.32652 5.13472 2.99848C6.33016 2.50595 7.68084 2.19939 8.99969 2.01933C10.3186 1.83889 11.6053 1.78373 12.6757 1.7838C13.0802 1.7838 13.4536 1.79164 13.7866 1.80342C12.416 2.45033 10.5491 3.45098 8.60747 4.85798C8.60994 4.82936 8.61259 4.80042 8.61563 4.77105C8.64769 4.45714 8.71206 4.10039 8.83022 3.73902C8.91934 3.46611 8.77038 3.17261 8.4975 3.08348C8.2246 2.99436 7.93109 3.14333 7.84197 3.4162C7.69613 3.86295 7.61972 4.29142 7.58141 4.66517C7.55591 4.91439 7.54741 5.13939 7.54741 5.3298C7.54741 5.42495 7.54953 5.51148 7.55275 5.58811C7.55375 5.61192 7.55487 5.63452 7.55609 5.65636C7.30669 5.85473 7.05725 6.05964 6.80878 6.27167C5.89066 7.05536 4.98528 7.93373 4.13759 8.91161C4.13231 8.80405 4.12944 8.69727 4.12944 8.59158C4.12944 8.34752 4.14288 8.10873 4.16716 7.87664C4.23756 7.20239 4.39969 6.58445 4.5855 6.06142C4.68156 5.79086 4.54013 5.49367 4.26963 5.39761C3.99906 5.30155 3.70188 5.44298 3.60581 5.71348C3.39775 6.29961 3.214 6.99586 3.13316 7.76852C3.10538 8.03439 3.08981 8.30923 3.08981 8.59155C3.08978 9.05342 3.13191 9.53552 3.22972 10.0295C3.12672 10.1651 3.0245 10.3018 2.92406 10.4409C2.51891 11.0017 2.13578 11.5906 1.78097 12.2079ZM14.0172 3.54583C13.6993 4.70445 13.3622 6.38105 13.0836 8.80564C12.9686 9.80642 12.7242 10.6547 12.382 11.3636C12.1251 11.8954 11.8133 12.3494 11.4559 12.7339C10.9195 13.3102 10.2798 13.7323 9.55553 14.0148C8.8315 14.2969 8.02191 14.4373 7.15703 14.4373C6.34481 14.4374 5.48472 14.3132 4.60809 14.0684C3.88109 13.8655 3.14291 13.5795 2.4115 13.2147C2.81994 12.451 3.27563 11.7298 3.76681 11.0495C3.84038 10.9477 3.915 10.847 3.99013 10.747C4.11291 10.7907 4.30147 10.854 4.54441 10.9239C4.98469 11.0505 5.60244 11.1987 6.32741 11.2885C6.72503 11.3377 7.155 11.3692 7.60584 11.3692C7.97697 11.3692 8.36222 11.3479 8.75497 11.297C9.03969 11.2601 9.24063 10.9995 9.20375 10.7147C9.16687 10.43 8.90619 10.2291 8.62147 10.266C8.27781 10.3105 7.93697 10.3296 7.60578 10.3296C7.20353 10.3296 6.81566 10.3014 6.45497 10.2567C5.79738 10.1755 5.2305 10.0395 4.83181 9.92477C4.77738 9.90911 4.72641 9.89389 4.67844 9.87923C5.76 8.58711 6.95775 7.46402 8.16284 6.50173C8.20325 6.51858 8.24709 6.5362 8.29463 6.55445C8.56894 6.65964 8.96028 6.78339 9.44631 6.86589C9.77031 6.92086 10.1364 6.95745 10.537 6.95745C10.7374 6.95745 10.9463 6.9483 11.1628 6.92777C11.4487 6.90067 11.6584 6.64698 11.6313 6.36117C11.6042 6.07536 11.3505 5.86564 11.0647 5.89273C10.8818 5.91005 10.7057 5.9178 10.5371 5.9178C10.1997 5.9178 9.89191 5.88698 9.62028 5.84089C9.45241 5.81239 9.29856 5.77802 9.16006 5.74161C9.26444 5.66558 9.36872 5.59048 9.47269 5.51686C11.2725 4.2417 12.9969 3.32345 14.2656 2.72677C14.1851 2.96608 14.1019 3.23745 14.0172 3.54583Z"
          fill="white"
        />
      </svg>
      <div>{buttonText}</div>
    </div>
    <div class="uturn-product-page-button-container-pricing">
      <div
        bind:this={currentPriceRef}
        class="uturn-product-page-button-container-pricing-return"
        style="line-height:15px"
      >
        ${data.alternative[0]?.shop_variant_price.toFixed(2) ?? "N/A"}
      </div>
      <div
        bind:this={originalPriceRef}
        class="uturn-product-page-button-container-pricing-original"
      >
        ${data?.alternative[0]?.shop_original_variant_price.toFixed(2) ?? "N/A"}
      </div>
    </div>
  </section>
{/if}

<style>
  .uturn-product-page-button-container {
    background-color: #339760;
    padding: 8.5px 12px;
    color: #ffffff;
    position: relative;
    min-height: 18px;
    cursor: pointer;
    display: flex;
  }

  .uturn-product-page-button-container-text {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    width: 90%;
  }

  .uturn-product-page-button-container-pricing {
    text-align: end;
    margin: auto;
  }

  .uturn-product-page-button-container-pricing-original {
    text-decoration-line: line-through;
    opacity: 0.7;
  }
</style>
